import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import { CONFIG_ITEM_KEYS } from '../../../config-items/config-item-keys';
import { createEditorPluginAIConfigItemMarkdown } from '../../../config-items/config-items';
import { Icon } from '../../assets/icons/findActionItems';
import {
	createInsertAtCurrentPosition,
	createInsertAtTop,
} from '../../config-item-actions/markdown';
import { isMinLength } from '../../config-item-visible/visibility-utils';

import { messages } from './messages';

const SELECTION_TYPE = 'empty';

export const findActionItemsConfigItem = createEditorPluginAIConfigItemMarkdown({
	key: CONFIG_ITEM_KEYS.FIND_ACTION_ITEMS,
	title: messages.title,
	description: messages.description,
	selectionType: SELECTION_TYPE,
	intentSchemaId: 'action_items_intent_schema.json',
	icon: ({ shownAt }) => <Icon shownAt={shownAt} />,
	isVisible: ({ editorView }) => isMinLength({ editorView, minLength: 1 }),
	actions: [
		createInsertAtTop({ appearance: 'secondary' }),
		createInsertAtCurrentPosition({ appearance: 'primary' }),
	],
	getBackendModel: () => {
		if (fg('platform_editor_ai_assistance_service')) {
			return 'assistance-service';
		}

		return 'xp-gen-ai';
	},
});
